import React from 'react'
import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import ListRequisites from './routes/ListRequisites/ListRequisites'
import FastTrackRequisites from './routes/FastTrackRequisites/FastTrackRequisites'
import { EditRequisite } from './routes/EditRequisite/EditRequisite'
import CashboxesPriorities from './routes/CashboxesPriorities'
import CashboxesList from './routes/CashboxesList'
import { CashBoxDetails } from './routes/CashBoxDetails'
import PaymentAdapters from './routes/PaymentAdapters/PaymentAdapters'
import PaymentAdaptersPriorities from './routes/PaymentAdapterPriorities/PaymentAdapterPriorities'
import { PrivateRoute } from '../auth/PrivateRoute'
import { ROLE } from '../auth'
import ResuisiteClients from './routes/ResuisiteClients/ResuisiteClients'
import MessageTemplatePage from './routes/MessageTemplate'
import SystemSettingsPage from './routes/SystemSettings'
import RequisitePage from './routes/Requisites'
import MerchantsList from './routes/MerchantsList'
import MerchantDetail from './routes/MerchantDetail'
import MerchantLedgerHistoryPage from './routes/MerchantLedgerHistory'
import PaymentAdaptersPage from './routes/PaymentAdapters'
import ProviderManagement from './routes/PaymentAdapters/component/provider-management/ProviderManagement'
import { OverpaymentReasonsPage } from './routes/OverpaymentReasons'
import { MatchingProfilesPage } from './routes/MatchingProfiles'
import { DisputeReasonsPage } from './routes/DisputeReasons'
import { DepositCancelReasonsPage } from './routes/DepositCancelReasons'
import CommissionRulesPage from './routes/CommissionRules/CommissionRulesPage'
import { CoverageMapPage, ConfigEditorPage } from './routes/AdapterRoutingCoverage'

const SettingsPage: React.FC = () => {
  return (
    <Routes>      
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route
          path='/cashboxes'
          element={
            <PrivateRoute
              roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}
            >
              <CashboxesList />
            </PrivateRoute>
          }
        />

        <Route
          path='/cashbox/:id'
          element={
            <PrivateRoute
              roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}
            >
              <CashBoxDetails />
            </PrivateRoute>
          }
        />

        <Route index element={<Navigate to='/requisite' />} />
      </Route>
      <Route
        path='/cashboxes-priorities'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}>
            <CashboxesPriorities />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to='/cashboxes-priorities' />} />
      </Route>      
      <Route
        path='/payment-adapter-priorities'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}>
            <PaymentAdaptersPriorities />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to='/payment-adapters-priorities' />} />
      </Route>
      <Route
        path='/adapter-routing'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR]}>
            <CoverageMapPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/adapter-routing/config/:contextId'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR]}>
            <ConfigEditorPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/merchants'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}>
            <MerchantsList />
          </PrivateRoute>
        }
      />
      <Route
        path='/merchants/:id'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}>
            <MerchantDetail />
          </PrivateRoute>
        }
      />
      <Route
        path='/merchants/:id/ledger-history'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}>
            <MerchantLedgerHistoryPage />
          </PrivateRoute>
        }
      />
      <Route path='/requisite/*' element={<RequisitePage />} />
      <Route path='/message/*' element={<MessageTemplatePage />} />
      <Route path='/payment-adapters' element={<ProviderManagement />} />
      <Route path='/system' element={<SystemSettingsPage />} />
      <Route
        path='/overpayment-reasons'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
            <OverpaymentReasonsPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/matching-profiles'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
            <MatchingProfilesPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/dispute-reasons'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
            <DisputeReasonsPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/deposit-cancel-reasons'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER]}>
            <DepositCancelReasonsPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/commission-rules/*'
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}>
            <CommissionRulesPage />
          </PrivateRoute>
        }
      />
    </Routes>
  )
}

export default SettingsPage
